/* import __COLOCATED_TEMPLATE__ from './business.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();